import { render } from "./ReportsEntriesTable.vue?vue&type=template&id=b6b7725e&ts=true"
import script from "./ReportsEntriesTable.vue?vue&type=script&lang=ts"
export * from "./ReportsEntriesTable.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__